module.exports = __webpack_public_path__ + "media/images/phone-icon-93bf30deba0a58d83b6f3b9b187ed0aa.svg";